const ErrorMessage = ({msg, onClose, isVisible}) => {
    return isVisible && (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
            <strong>Error:</strong>{msg}
            <button type="button" className={"btn-close"} onClick={onClose}></button>
        </div>
    );
}

export default ErrorMessage